"use client";
import React, { useState } from "react";

export const dynamic = "force-dynamic";

const OurDeliveredEnterprise = () => {
    const [Data, setData] = useState(1);
    const [Active, setActive] = useState(1);

    const Warehousing = (e, id) => {
        e.preventDefault();
        setData(id);
        setActive(id);
    };

    return (
        <>
            <div className="container mx-auto flex flex-wrap lg:flex-nowrap justify-between md:gap-5  gap-1 font-bold  px-4 md:px-24 lg:px-24 xl:px-0 md:mt-[140px] pt-10">
                <div>
                    <div>
                        <h2 className="font-bold  leading-5 font-manrope lg:leading-[65px]  text-center xl:text-[45px]  lg:text-[40px] md:text-[25px] text-[20px] py-5   ">
                            Our Delivered Enterprise <br></br>
                            <span className="text-[#410EAD]">
                                Software Solutions
                            </span>
                        </h2>
                        <p className="text-[#59587C]  leading-5 text-[17px] font-normal py-5">
                            Our award and recognitions validate that when businesses think about expanding into mobile segment, we are the top Web3 and blockchain app development company in US they turn to.
                        </p>
                    </div>
                    <div className=" flex  flex-wrap gap-3  py-5">
                        <button
                            className={
                                Active === 1
                                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 font-manrope"
                                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 font-manrope"
                            }
                            onClick={(e) => {
                                Warehousing(e, 1);
                            }}
                        >
                            Data Warehousing
                        </button>
                        <button
                            className={
                                Active === 2
                                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 font-manrope"
                            }
                            onClick={(e) => {
                                Warehousing(e, 2);
                            }}
                        >
                            SCM
                        </button>
                        <button
                            className={
                                Active === 3
                                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 font-manrope"
                            }
                            onClick={(e) => {
                                Warehousing(e, 3);
                            }}
                        >
                            ERP
                        </button>
                        <button
                            className={
                                Active === 4
                                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 font-manrope"
                            }
                            onClick={(e) => {
                                Warehousing(e, 4);
                            }}
                        >
                            Core IT Modernization
                        </button>
                        <button
                            className={
                                Active === 5
                                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 font-manrope"
                            }
                            onClick={(e) => {
                                Warehousing(e, 5);
                            }}
                        >
                            CRM
                        </button>
                    </div>
                </div>
                <div>
                    <div className=" rounded-xl items-center border-[#FFFFFF] shadow shadow-[#410EAD] border-solid py-5 px-5  my-5">
                        <div className=" rounded-xl items-center text-center border-[#FFFFFF] shadow shadow-[#410EAD] border-solid py-10  md:px-10 my-2">
                            {Data === 1 ? (
                                <>
                                    <h1 className="text-[#410EAD]  font-bold font-manrope text-[20px]">
                                        Data Warehousing
                                    </h1>
                                    <p className="py-5 font-normal leading-5 text-[17px] text-[#59587C] ">
                                        We offer a full suite of data
                                        warehousing services starting from data
                                        warehouse consulting and development to
                                        migration and support.
                                    </p>
                                    <span className="text-sm lg:text-lg   text-[#410EAD] font-bold  px-2 md:px-5 py-2.5 ease-in-out duration-700 font-manrope">
                                        Connect with Our Enterprise Service
                                        Expert
                                    </span>
                                </>
                            ) : null}
                            {Data === 2 ? (
                                <>
                                    <h1 className="text-[#410EAD]  font-bold font-manrope text-[20px]">
                                        SCM
                                    </h1>
                                    <p className="py-5 font-normal leading-5 text-[17px] text-[#59587C] ">
                                        Our custom supply chain software
                                        solutions including inventory
                                        management, risk management, and more
                                        helps enterprises manage agile,
                                        resilient supply chains that drive
                                        business growth.
                                    </p>
                                    <span
                                        className="text-sm lg:text-lg   text-[#410EAD] font-bold  px-2 md:px-5 py-2.5 ease-in-out duration-700 font-manrope"
                                    >
                                        Connect with Our Enterprise Service
                                        Expert
                                    </span>
                                </>
                            ) : null}
                            {Data === 3 ? (
                                <>
                                    <h1 className="text-[#410EAD]  font-bold font-manrope text-[20px]">
                                        ERP
                                    </h1>
                                    <p className="py-5 font-normal leading-5 text-[17px] text-[#59587C] ">
                                        Our team through ERP services such as
                                        consultation, custom software
                                        development, and implementation helps
                                        organizations map all the risks and
                                        opportunities of ERP solutions. Read our
                                        guide on ERP software development
                                    </p>
                                    <span
                                        className="text-sm lg:text-lg   text-[#410EAD] font-bold  px-2 md:px-5 py-2.5 ease-in-out duration-700 font-manrope"
                                    >
                                        Connect with Our Enterprise Service
                                        Expert
                                    </span>
                                </>
                            ) : null}
                            {Data === 4 ? (
                                <>
                                    <h1 className="text-[#410EAD]  font-bold font-manrope text-[20px]">
                                        Core IT Modernization
                                    </h1>
                                    <p className="py-5 font-normal leading-5 text-[17px] text-[#59587C] ">
                                        As an enterprise custom software
                                        development company, we offer a myriad
                                        of ITmodernization services including
                                        consultation, software re-engineering,
                                        and cloud migration.
                                    </p>
                                    <span
                                        className="text-sm lg:text-lg   text-[#410EAD] font-bold  px-2 md:px-5 py-2.5 ease-in-out duration-700 font-manrope"
                                    >
                                        Connect with Our Enterprise Service
                                        Expert
                                    </span>
                                </>
                            ) : null}
                            {Data === 5 ? (
                                <>
                                    <h1 className="text-[#410EAD]  font-bold font-manrope text-[20px]">
                                        CRM
                                    </h1>
                                    <p className="py-5 font-normal leading-5 text-[17px] text-[#59587C] ">
                                        Our proficient team efficiently
                                        integrates CRM functionalities with the
                                        enterprisesolution allowing you to keep
                                        a track of all the client activities
                                        within a single digital space.
                                    </p>
                                    <span
                                        className="text-sm lg:text-lg   text-[#410EAD] font-bold  px-2 md:px-5 py-2.5 ease-in-out duration-700 font-manrope"
                                    >
                                        Connect with Our Enterprise Service
                                        Expert
                                    </span>
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OurDeliveredEnterprise;
